import { axiosInstance } from '.'
import {
  GET_NEWSLETTER_SUBSCRIBER_DETAILS,
  SUBSCRIBE_TO_NEWSLETTER,
  UNSUBSCRIBE_FROM_NEWSLETTER,
} from './endpoints'

export const newsletterServices = {
  subscribeToNewsletter: async (
    data: { name: string; email: string; marketingConsent: boolean },
    headers: { [key: string]: string },
  ) => {
    try {
      const res = await axiosInstance.post(SUBSCRIBE_TO_NEWSLETTER, data, { headers })
      return res
    } catch (error: any) {
      return error.response
    }
  },
  getNewsletterSubscriberDetails: async (email: string, headers: { [key: string]: string }) => {
    try {
      const res = await axiosInstance.post(
        GET_NEWSLETTER_SUBSCRIBER_DETAILS,
        { email },
        {
          headers,
        },
      )
      return res
    } catch (error: any) {
      return error.response
    }
  },
  unsubscribeFromNewsletter: async (email: string, headers: { [key: string]: string }) => {
    try {
      const res = await axiosInstance.post(UNSUBSCRIBE_FROM_NEWSLETTER, { email }, { headers })
      return res
    } catch (error: any) {
      return error.response
    }
  },
}
